import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ScrollBlockingService {
  private isBlocked = false;
  private scrollPosition = 0;

  block() {
    this.isBlocked = true;
    this.scrollPosition = window.pageYOffset;
    document.body.style.overflow = 'hidden';
    document.body.style.position = 'fixed';
    document.body.style.top = `-${this.scrollPosition}px`;
    document.body.style.width = `100%`;
  }

  unblock() {
    this.isBlocked = false;
    document.body.style.removeProperty('overflow');
    document.body.style.removeProperty('position');
    document.body.style.removeProperty('top');
    document.body.style.removeProperty('width');
    window.scrollTo(0, this.scrollPosition);
  }
}
